import { useContext } from "react";
import {
  Box,
  Button,
} from "@mui/material";
import { CityProfileVisibleContext } from "../../contexts/CityProfileVisibleContext";

// This button controls the display of the right panel
export default function TenMinuteButton() {
  const { visible, setVis } = useContext(CityProfileVisibleContext);
  return (
    <Box className="subnavbar__button-container">
      <Button
        className="subnavbar__button"
        color="sun"
        variant="contained"
        sx={{ borderRadius: 0, height: "45px" }}
        disableElevation
        onClick={() => {
          setVis(!visible);
        }}
      >
        10-Minute Walk Statistics
      </Button>
    </Box>
  );
}
